/** @format */

/* eslint react-hooks/rules-of-hooks: "warn", @typescript-eslint/prefer-nullish-coalescing: "warn" */
import React, { useContext } from 'react';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { StockAlertPageType } from '@toucan/client/global/product';

import { CreateAlert, type CreateAlertModel } from './components/create-alert';

export type { CreateAlertModel };

export function alertHelper(
    baseModel?: CreateAlertModel,
    pageType?: StockAlertPageType
) {
    const { setModalContent, setModalVisible, setModalSize } =
        useContext(ApplicationContext);

    /**
     * Handles opening the modal when the
     * 'Create an alert' button is clicked
     *
     * @param {Model} model the model data
     */
    function handleOpenCreateAlertModal(model?: CreateAlertModel): void {
        const alertModel = model || baseModel;

        if (!alertModel) {
            return;
        }

        setModalContent(
            <CreateAlert
                model={alertModel}
                onClose={() => {
                    setModalVisible(false);
                }}
                pageType={pageType}
            />
        );
        setModalSize(ModalSize.LARGE);
        setModalVisible(true);
    }

    return {
        handleOpenCreateAlertModal,
    };
}
